import { createTheme } from "@mui/material/styles";

const lightTokens = {
  bg: "#FEFFF6",
  surface: "#FFFFFF",
  appBar: "#03514D",
  surface2: "#F2F8F7",
  surface3: "#E4F0EF",
  border: "rgba(3,81,77,0.08)",
  border2: "rgba(3,81,77,0.14)",
  border3: "rgba(3,81,77,0.24)",
  text: "#03514D",
  text2: "#4A7A78",
  text3: "#7A9E9C",
  accent: "#28B3B4",
  accent2: "rgba(40,179,180,0.12)",
  gold: "#D6DF27",
  goldText: "#6B7300",
  gold2: "rgba(214,223,39,0.18)",
  steel: "#03514D",
  steel2: "rgba(3,81,77,0.12)",
  sage: "#28B3B4",
  sage2: "rgba(40,179,180,0.12)",
  purple: "#03514D",
  purple2: "rgba(3,81,77,0.12)",
  cyan: "#28B3B4",
};

const darkTokens = {
  bg: "#060E0D",
  surface: "#0D1A18",
  appBar: "#03514D",
  surface2: "#152421",
  surface3: "#1D302D",
  border: "rgba(40,179,180,0.18)",       // teal border
  border2: "rgba(214,223,39,0.20)",      // yellow-green border
  border3: "rgba(214,223,39,0.35)",      // yellow-green border strong
  text: "#F5FFF9",
  text2: "#C8E8E6",
  text3: "#7AADA9",
  accent: "#28B3B4",                     // teal as primary accent
  accent2: "rgba(40,179,180,0.15)",      // teal accent glow
  gold: "#D6DF27",                       // yellow-green for highlights/badges
  goldText: "#D6DF27",                   // yellow-green for text highlights
  gold2: "rgba(214,223,39,0.18)",        // yellow-green soft fill
  steel: "#28B3B4",                      // teal for steel elements
  steel2: "rgba(40,179,180,0.12)",       // teal soft fill
  sage: "#D6DF27",                       // yellow-green for sage elements
  sage2: "rgba(214,223,39,0.15)",        // yellow-green soft fill
  purple: "#28B3B4",                     // teal for purple-role elements
  purple2: "rgba(40,179,180,0.12)",      // teal soft fill
  cyan: "#28B3B4",                       // teal
};

const buildTheme = (mode, tokens) =>
  createTheme({
    palette: {
      mode,
      background: {
        default: tokens.bg,
        paper: tokens.surface,
      },
      text: {
        primary: tokens.text,
        secondary: tokens.text2,
        disabled: tokens.text3,
      },
      primary: {
        main: tokens.accent,
      },
      divider: tokens.border2,
    },
    typography: {
      fontFamily: "'Inter', sans-serif",
    },
    custom: tokens,
  });

export const darkTheme = buildTheme("dark", darkTokens);
export const lightTheme = buildTheme("light", lightTokens);